var _style, _rect, _path, _path2, _polygon;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOneWayDirection(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Lager_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 80 80",
    height: 80,
    width: 80,
    style: {
      enableBackground: "new 0 0 80 80"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#002E6D;stroke:#002E6D;stroke-width:0.15;}\r\n\t.st1{fill:#FFFFFF;}\r\n\t.st2{fill:#002E6D;}\r\n")), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5.5,
    y: 25.7,
    className: "st0",
    width: 68,
    height: 25.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M8.5,25.7h62.1c1.6,0,3,1.3,3,3v19.6c0,1.6-1.3,3-3,3H8.5c-1.6,0-3-1.3-3-3V28.6C5.5,27,6.9,25.7,8.5,25.7z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M8.5,26.9h62.1c0.5,0,0.9,0.2,1.2,0.5c0.3,0.3,0.5,0.8,0.5,1.2v19.6c0,0.5-0.2,0.9-0.5,1.2 c-0.3,0.3-0.8,0.5-1.2,0.5H8.5c-0.5,0-0.9-0.2-1.2-0.5c-0.3-0.3-0.5-0.8-0.5-1.2V28.6c0-0.5,0.2-0.9,0.5-1.2 C7.6,27.1,8,26.9,8.5,26.9z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "52.2,40.1 18.2,40.1 18.2,36.7 52.2,36.7 52.2,29.9 60.7,38.4 52.2,46.9 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOneWayDirection);
export default __webpack_public_path__ + "static/media/one-way-direction.b0035d054ab7eec9d75dc068a5a0506e.svg";
export { ForwardRef as ReactComponent };